import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../../config/apiClients";
import { NewsState } from "../../../types";
import { News } from "../../../../utils/types";

const initialState: NewsState = {
  isLoading: false,
  news: []
}

export const getAllNews = createAsyncThunk(
  "/news/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/news/getAll');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch News' });
    }
  }
);

export const createNews = createAsyncThunk(
  "/news/create",
  async (news: News, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/news/create', news);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Add News' });
    }
  }
)

export const updateNews = createAsyncThunk(
  "/esouq/product/update",
  async (news: News, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/news/update', { ...news, id: news._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update News' });
    }
  }
)

export const deleteNews = createAsyncThunk(
  "/news/delete",
  async (newsId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete('/news/delete', { data: { newsId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Delete News' });
    }
  }
)

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    updateNewsItem: (state, action) => {
      const index = state.news.findIndex((news) => news._id === action.payload._id);
      if (index !== -1) {
        state.news[index] = action.payload;
      }
    },
    deleteNewsItem: (state, action) => {
      state.news = state.news.filter((item) => item._id !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllNews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.news = action.payload.payload.allnews;
      })
      .addCase(getAllNews.rejected, (state) => {
        state.isLoading = false;
        state.news = [];
      })
      .addCase(createNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNews.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createNews.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNews.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateNews.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteNews.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteNews.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { updateNewsItem, deleteNewsItem } = newsSlice.actions;

export default newsSlice.reducer;